import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { Swiper } from '@mssgme/ui';
import { usePageData } from '../../../hooks';
import { ServiceContent, ThemedModal } from '../../../UI';

import styles from './ServicesModal.scss';

export function ServicesModal({
    services,
    contacts,
    activeIndex,
    interactive,
    onClose,
    onClosing,
    themeStyles,
    handleHash,
}) {
    const page = usePageData();
    const history = useHistory();
    const hasMultipleServices = services.length > 1;

    const contactBlocks = useMemo(
        () =>
            contacts
                .filter(({ enabled }) => enabled)
                .map(({ blockId }) => page.blocks.find(({ _id }) => _id === blockId)),
        [page, contacts]
    );

    const handleSlideChange = useCallback(
        (swiper) => {
            if (handleHash) {
                history.replace('#' + services[swiper.realIndex]._id);
            }
        },
        [handleHash, services]
    );

    return (
        <ThemedModal overlay handleHash showHeader={false} onClose={onClose}>
            <div className={styles.content}>
                <Swiper
                    className={styles.swiper}
                    allowTouchMove={hasMultipleServices}
                    initialSlide={activeIndex}
                    noSwipingClass={styles.noSwiping}
                    speed={600}
                    pagination={false}
                    onInit={handleSlideChange}
                    onSlideChange={handleSlideChange}
                >
                    {services.map((service, index) =>
                        Object.assign(
                            ({ isActive, isPrev, isNext }) => (
                                <ServiceContent
                                    themeStyles={themeStyles}
                                    service={service}
                                    contacts={contactBlocks}
                                    isActive={isActive}
                                    isPrev={isPrev}
                                    isNext={isNext}
                                    interactive={interactive}
                                    onClose={onClose}
                                />
                            ),
                            { key: service._id || index }
                        )
                    )}
                </Swiper>
            </div>
        </ThemedModal>
    );
}

ServicesModal.propTypes = {
    services: PropTypes.array.isRequired,
    contacts: PropTypes.array.isRequired,
    activeIndex: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    onClosing: PropTypes.func,
    themeStyles: PropTypes.object.isRequired,
    handleHash: PropTypes.bool,
    interactive: PropTypes.bool,
};

ServicesModal.defaultProps = {
    handleHash: true,
    interactive: true,
};
